// extracted by mini-css-extract-plugin
export default {"selectedFilters":"SelectedFilters_selectedFilters__iChJn"};